import { environment as ENV } from '@environment';

export const abandonedReservationApi = {
  retarget: {
    get_retarget: `${ENV.api.services}/api/travel-proxy-ms/itinerary/retarget`,
  },
  cancel: `${ENV.api.services}/api/travel-cancellations/cancellations`
};
